import { environment } from '../environments/environment';

export const DOM436_API = environment.api
export const IMG_CAMINHO = environment.imagens_caminho
